<script setup>
import { computed, onMounted, useTemplateRef, getCurrentInstance } from 'vue';
import MemeGenerator from '/app/components/challenge-show/MemeGenerator.vue';
import { useFormContext } from '/app/composables/form';
import { config } from '/app/config';

const baseURL = config.app.baseURL;

const form = useFormContext();
const instance = getCurrentInstance();
const parent = instance.parent.proxy;
const memeGenerator = useTemplateRef('memeGenerator');

const image = computed(() => parent.form.fields.challenge.primary_image || `${baseURL}/img/placeholder/meme-03.png`);
const title = computed(() => parent.form.fields.idea.title || 'This is the title');
const description = computed(() => parent.form.fields.idea.description || 'This is the description');
const isCaption = computed(() => parent.form.fields.challenge.caption_solution_format === 'caption');

onMounted(() => {
    const KEY = 'upload-idea-test';

    if (title.value) {
        form.middlewares.set(KEY, async (fields) => {
            const { url } = await memeGenerator.value.uploadImage();
            fields.idea.primary_image = url;
        });
    } else {
        form.middlewares.delete(KEY);
    }
});
</script>

<template>
    <MemeGenerator
        v-if="isCaption"
        :punchline-text="title"
        :image-src="image"
        class="mx-auto max-w-full"
        ref="memeGenerator"
    />
    <MemeGenerator
        v-else
        :setup-text="title"
        :punchline-text="description"
        :image-src="image"
        class="mx-auto max-w-full"
        ref="memeGenerator"
    />
</template>
